import React, { useEffect, useRef, useState } from "react";
import { Button, DownloadIcon } from "@pd/pd-ui-kit";
import { Flex } from "antd";

import Preloader from "~/components/Preloader";
import DynamicTable from "~/pages/StaffBonus/DynamicTable";
import StaffTrainingFilter from "~/pages/StaffTraining/ui/StaffTrainingFilter/StaffTrainingFilter";
import Wrapper from "~/shared/ui/Wrapper";
import { IDynamicTable } from "~/app/type/common";
import { useEmployee } from "~/entity/Employee";
import { EmployeeEducationStatisticsCoursesReportGetterParams } from "~/entity/Employee/model/schema";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { toServer } from "~/pages/StaffTraining/ui/StaffTrainingFilter/model/adapter";
import { TTrainingFilter } from "~/pages/StaffTraining/ui/StaffTrainingFilter/model/config";
import { useNotify } from "~/shared/hooks/useNotify";

import s from "./StaffTraining.module.less";

export const StaffTraining = () => {
  const setQuerySearch = useURLParamsSetter();
  const settedFilter = useURLParamsGetter<TTrainingFilter>();
  const { getStatisticsCoursesReport, getStatisticsCoursesReportFileHash } =
    useEmployee();

  const onSubmit = (value: TTrainingFilter) => {
    const normalizedValue = {
      ...value,
      filterExpectations: value.filterExpectations?.flatMap((item) =>
        String(item.value)
          .split(",")
          .map((v) => ({
            ...item,
            value: v.trim(),
          })),
      ),
    };

    setQuerySearch(normalizedValue);
  };
  const { notifyReport } = useNotify();
  const [loadingReportDownload, setLoadingReportDownload] = useState(false);
  const onDownload = () => {
    setLoadingReportDownload(true);
    getStatisticsCoursesReportFileHash(toServer(settedFilter))
      .then((res) => {
        if (res.data.fileHash) {
          notifyReport(res.data.fileHash);
        }
      })
      .finally(() => setLoadingReportDownload(false));
  };

  const [loadingReport, setLoadingReport] = useState(false);
  const [trainingTable, setTrainingTable] = useState<{ table: IDynamicTable }>(
    null,
  );
  const debouncedRef = useRef(null);

  const getReportByFilter = (
    filter: EmployeeEducationStatisticsCoursesReportGetterParams,
  ) => {
    setLoadingReport(true);
    getStatisticsCoursesReport(filter)
      .then((res) => {
        setTrainingTable(res.data);
      })
      .finally(() => setLoadingReport(false));
  };

  useEffect(() => {
    clearTimeout(debouncedRef.current);
    if (!!Object.keys(settedFilter).length) {
      debouncedRef.current = setTimeout(() => {
        getReportByFilter(toServer(settedFilter));
      }, 0);
    }
  }, [settedFilter]);

  const isLoading = loadingReport;

  return (
    <Wrapper.Content
      title={"Обученность сотрудников"}
      filterComponent={<StaffTrainingFilter onSubmit={onSubmit} />}
    >
      <Flex className={s.actionRow}>
        <Button
          color={"secondary"}
          variant={"filled"}
          bold
          fontSize="12"
          size={"middle"}
          radius={30}
          icon={<DownloadIcon size={16} fill="#495a64" />}
          onClick={() => onDownload()}
          disabled={loadingReportDownload}
        >
          Скачать отчет
        </Button>
      </Flex>
      <div className={s.wrapper}>
        {!isLoading ? (
          !!trainingTable?.table ? (
            <DynamicTable table={trainingTable.table} />
          ) : (
            <></>
          )
        ) : (
          <Preloader />
        )}
      </div>
    </Wrapper.Content>
  );
};
